<template>
  <div class="rythm-v">
    <radio-toggle
      class="radio-group--inline"
      id="efficiency_percentage_done"
      name="efficiency_percentage_done"
      label="Test réalisé ?"
      v-model="efficiency_percentage_done"
      @input="resetScore"
      v-bind="$attrs"
      required
    ></radio-toggle>

    <div class="rythm-v" v-if="parseInt(efficiency_percentage_done)">
      <p class="required">
        Depuis le début de votre traitement, comment qualifieriez-vous le changement (s’il existe) sur la limitation de vos activités, vos symptômes, vos émotions et tout ce qui fait votre quotidien.
        <br />Cochez la phrase qui vous correspond.
      </p>

      <radio-group
        class="radio-group"
        id="efficiency_percentage"
        ref="efficiency_percentage"
        :radios="efficiency_percentage_options"
        name="efficiency_percentage"
        v-model="efficiency_percentage"
        v-bind="$attrs"
        @change="emitScore"
        :required="true"
      ></radio-group>
    </div>
  </div>
</template>

<script>
import radioGroup from "@/components/radioGroup.vue";
import radioToggle from "@/components/radioToggle.vue";

export default {
  name: "EfficiencyPercentage",
  inheritAttrs: false,
  props: ["value"],

  components: {
    radioGroup,
    radioToggle,
  },

  data() {
    return {
      attrsObject: null,
      efficiency_percentage_done: "",
      efficiency_percentage: "",
      efficiency_percentage_options: [
        { value: "Pas de changement ou c’est devenu pire" },
        { value: "Presque pareil, pratiquement pas d’amélioration" },
        { value: "Un peu mieux, mais pas de changement notable" },
        { value: "Plutôt mieux mais le changement ne fait pas de réelle différence" },
        { value: "Mieux, le changement est modéré mais notable" },
        { value: "Mieux, avec sans aucun doute une amélioration réelle qui fait la différence" },
        { value: "Nettement mieux, une amélioration considérable qui fait toute la différence" },
      ],
    };
  },

  methods: {
    emitScore() {
      this.$emit("input", {
        efficiency_percentage_done: this.efficiency_percentage_done,
        efficiency_percentage: this.efficiency_percentage,
      });
    },

    resetScore() {
      if (!parseInt(this.efficiency_percentage_done)) {
        this.efficiency_percentage = "";
      }
      this.emitScore();
    },
  },

  watch: {
    // Init data values from component props ("values")
    value: {
      immediate: true,
      deep: true,
      handler: function(data) {
        this.efficiency_percentage_done = data?.efficiency_percentage_done || "";
        this.efficiency_percentage = data?.efficiency_percentage || "";
      },
    },
  },
};
</script>
